import React from 'react';

import { TextProps } from './types';
import { TextStyled } from './styles';

export const Text = ({ variant, content }: TextProps): JSX.Element => <TextStyled variant={variant}>{content}</TextStyled>;
